import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowLongRight"
});
const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.29128 12.5467L13.0148 7.28843C13.1617 7.12489 13.1617 6.87549 13.0148 6.71194L8.29133 1.45333C8.13366 1.2778 7.8649 1.26455 7.69104 1.42374L7.66166 1.45341L7.00911 2.18022C6.8623 2.34374 6.8623 2.59303 7.00912 2.75655L9.85737 5.92893L1.29998 5.92746C1.09135 5.92736 0.917805 6.07911 0.881788 6.27926L0.875 6.35646V7.64367C0.875 7.88063 1.06528 8.07272 1.29998 8.07277L9.85737 8.07342L7.00928 11.2438C6.86237 11.4074 6.86236 11.6568 7.00927 11.8203L7.66168 12.5467C7.81936 12.7222 8.08812 12.7355 8.26198 12.5763L8.29128 12.5467Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var arrow_long_right = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrow_long_right as default };
